<template>
  <div class="mf_card_bl questCard">
    <div>Vous pourrez entre autre et à tout moment :</div>
    <b-row class="mt-5">
      <b-col cols="12" md="5">
        <ul>
          <li>Obtenir un diagnostic gratuit de votre portefeuille</li>
          <li>L’optimiser selon vos envies (réduire les frais et l’empreinte carbone de votre portefeuille, gérer votre risque, optimiser votre fiscalité...)</li>
          <li>Obtenir un suivi personnalisé de long terme en fonction des portefeuilles d’experts</li>
        </ul>
      </b-col>
      <b-col cols="1"  style="align-self: center;">
        <b-iconstack font-scale="3">
          <b-icon stacked icon="circle-fill" style="color:black"></b-icon>
          <b-icon stacked icon="plus" font-scale="2" style="color:#242527"></b-icon>
          <b-icon stacked icon="circle" style="color:black" scale="0.75" shift-v="-0.25"></b-icon>
        </b-iconstack>
      </b-col>
      <b-col cols="12" md="5">
        <ul>
          <li>Avoir accès à une sélection de titres personnalisés en fonction des recommandations d’analystes experts (Wall street Traders, Corporate Investor...)</li>
          <li>Analyser vos biais comportementaux</li>
          <li>Obtenir des analyses détaillées sur des positions (Sentiment ESG...)</li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
